import MapPositionStation, {
  ChangePositionData,
  StationData,
} from '@/components/google-map/MapPositionStation'
import { Dialog } from '@mui/material'
import { memo } from 'react'

interface Props {
  open: boolean
  interfaceId: number
  station?: StationData
  onClose: () => void
  onChangePosition: (data: ChangePositionData) => void
}

const PinStationOnMap = memo(
  ({ open, interfaceId, station, onClose, onChangePosition }: Props) => {
    return (
      <Dialog fullScreen open={open} scroll="paper">
        {open && (
          <MapPositionStation
            singleMode
            station={station}
            interfaceId={interfaceId}
            onClose={onClose}
            onDone={onChangePosition}
          />
        )}
      </Dialog>
    )
  },
)

export default PinStationOnMap
